import React from "react";
import "./button.styles.css";

const BUTTON_TYPE_CLASSES = {
  blackfordStone: "blackford-stone",
  deepMoss: "deep-moss",
  deepMossSmall: "deep-moss-small",
  lowlandsGreen: "lowlands-green",
  lowlandsGreenSmall: "lowlands-green-small",
  orange: "orange",
  orangeSmall: "orange-small",
  transparent: "transparent",
  burgerMenu: "burger-menu",
  navbar: "navbar",
  newPrayerSubmit: "new-prayer-submit",
};

const Button = ({ children, buttonType, ...otherProps }) => {
  return (
    <button
      className={`button-style-${BUTTON_TYPE_CLASSES[buttonType]}`}
      {...otherProps}
    >
      {children}
    </button>
  );
};

export default Button;
